import { TopBar as UITopBar } from "@webmotors/eleanor-ui";
import type { TopBarProps as UITopBarProps } from "@webmotors/eleanor-ui/webmotors/top-bar";

export function TopBar(props: Readonly<TopBarProps>) {
  return <UITopBar {...props} data-testid="bottom-sheet" />;
}

export type TopBarProps = UITopBarProps;
